/** Períodos do filtro da listagem de NF-es de entrada (Story, seção 1). */
export enum PeriodoNotaFiscalEntradaEnum {
  Hoje = 1,
  DaSemana = 2,
  DoMes = 3,
  Ultimos30Dias = 4,
  DoIntervalo = 5,
}
